import styled from 'styled-components';

/**
 * Shared styled components for operational data input forms
 * Used across all operational data input forms (revenue, employees, suppliers, production sites, etc.)
 */

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  font-size: var(--font-size__lg);
  font-weight: var(--font-weight__bold);
  margin: 0;
  color: var(--fgColor-default);
`;

export const ButtonSection = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: var(--space__sm);
`;

export const TableWrapper = styled.div`
  margin-top: var(--space__sm);
`;

export const EmptyState = styled.div`
  padding: var(--space__xl);
  text-align: center;
  color: var(--fgColor-muted);
  font-size: var(--font-size__md);
`;
